// Import toast function and styles from react-toastify
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Utility function to show success messages
export const SuccessToast = (message) => {
  toast.success(message, {
    position: "top-right", // Position on screen
    autoClose: 2500,       // Auto close after 2.5 seconds
    hideProgressBar: true, // Hides loading bar
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",        // Toast theme
  });
};

// Utility function to show error messages
export const FailureToast = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });
};

// Utility function to show informational/warning messages
export const InfoToast = (message) => {
  toast.warn(message, {
    position: "top-right",
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });
};
